// generated by genversion
export var version = '3.8.9';
//# sourceMappingURL=version.js.map